import {Component, Inject, LOCALE_ID, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatDataSourceGeneric} from '@Services/base/daoService';
import {ActionDataTable, ColumnDataTable, DataTableComponent} from '@Common/widgets/general/data-table';
import {Loaning} from '../../../common/services/loaning/loaning.model';
import {LoaningService} from '../../../common/services/loaning/loaning.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {SubSink} from '@Common/core/utils/subsink';
import {LoaningState} from '../../../common/services/loaning/loaning-states.enum';

@Component({
  selector: 'app-list-loanings',
  templateUrl: './list-loanings.component.html',
  styleUrls: ['./list-loanings.component.scss']
})
export class ListLoaningsComponent implements OnInit, OnDestroy {
  selectedTabIndex = 0;
  selectedLoanings: Loaning[] = [];
  IDX_TAB_LIST = 0;
  columns: ColumnDataTable[] = [{
    columnDef: 'status', header: 'Etat de la demande',
    display: (loaning: Loaning) => this.loaningSvc.getChipButton(loaning),
    sort: true, flex: 15
  },
    {
      columnDef: 'date_send', header: 'Date de la demande',
      display: (loaning: Loaning) => this.loaningSvc.getDateFr(loaning.date_send),
      sort: true, flex: 10
    },
    {
      columnDef: 'reference', header: 'Référence',
      display: (loaning: Loaning) => loaning.reference || '-',
      sort: true
    },
  ];
  actions: ActionDataTable[] = [{
      label: 'Visualiser', tooltip: 'Visualiser cette demande pour la gérer', icon: 'visibility',
      click: (loaning: Loaning) => this.addTabSelectedLoaning(loaning, this.IDX_TAB_LIST),
      iconcolor: 'accent',
    }];
  dsLoaning: MatDataSourceGeneric<Loaning> = new MatDataSourceGeneric<Loaning>();
  extraParams: Map<string, string> = new Map<string, string>([
    ['status_not_in', `${LoaningState.DRAFT}` ]
  ]);
  @ViewChild(DataTableComponent) dataTable: DataTableComponent;
  subSink = new SubSink();
  constructor(@Inject(LOCALE_ID) private locale: string,
              private router: Router,
              private route: ActivatedRoute,
              public dialog: MatDialog,
              private loaningSvc: LoaningService) {
    this.dsLoaning.daoService = loaningSvc;
  }

  ngOnInit(): void {
  }
  addTabSelectedLoaning(loaning: Loaning, begin: number) {
    this.selectedLoanings.push(loaning);
    this.selectedTabIndex = begin + this.selectedLoanings.length + 1;
  }
  closeLoaningTab(event: Event, loaning: Loaning) {
    event.stopImmediatePropagation();
    const index = this.selectedLoanings.indexOf(loaning);
    if (index > -1) {
      this.selectedLoanings.splice(index, 1);
      if (this.selectedLoanings.length === 0) {
        this.selectedTabIndex = 0;
      }
    }
    this.dataTable.reload();
  }
  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
